/**
 * Created by why on 2019/12/23.
 */
import {
  getMessageByCondition,
  messageSave,
  messageEdit,
  messageDelByIds,
  getById
} from '@/api/message-manage'

export default {
  state: {
    list: [],
    messageLoading: false,
    loadingSave: false,
    pageSize: 10,
    pageNum: 1,
    total: 0
  },
  mutations: {
    setMessageList (state, list) {
      state.list = list
    },
    setMessageLoading (state, loading) {
      state.messageLoading = loading
    },
    setMessagePageSize (state, pageSize) {
      state.pageSize = pageSize
    },
    setMessagePageNum (state, pageNum) {
      state.pageNum = pageNum
    },
    setMessageTotal (state, total) {
      state.total = total
    },
    setMessageLoadingSave (state, loadingSave) {
      state.loadingSave = loadingSave
    }
  },
  getters: {
    messageList: state => state.list,
    messageTotal: state => state.total,
    messageLoading: state => state.messageLoading,
    messageLoadingSave: state => state.loadingSave
  },
  actions: {
    getMessageByCondition ({ state, commit }, data) {
      commit('setMessageLoading', true)
      return new Promise((resolve, reject) => {
        getMessageByCondition(data).then(res => {
          const data = res.data.result
          const list = data.records
          const pageSize = data.pageSize
          const pageNum = data.pageNum
          const total = data.total
          commit('setMessageList', list)
          commit('setMessageLoading', false)
          commit('setMessagePageSize', pageSize)
          commit('setMessagePageNum', pageNum)
          commit('setMessageTotal', total)
          resolve(res)
        }).catch(err => {
          commit('setMessageLoading', false)
          reject(err)
        })
      })
    },
    messageSave ({ state, commit }, data) {
      commit('setMessageLoadingSave', true)
      return new Promise((resolve, reject) => {
        messageSave(data).then(res => {
          commit('setMessageLoadingSave', false)
          resolve(res)
        }).catch(err => {
          commit('setMessageLoadingSave', false)
          reject(err)
        })
      })
    },
    messageDelByIds ({ state, commit }, ids) {
      return new Promise((resolve, reject) => {
        messageDelByIds(ids).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    messageEdit ({ state, commit }, data) {
      commit('setMessageLoadingSave', true)
      return new Promise((resolve, reject) => {
        messageEdit(data).then(res => {
          commit('setMessageLoadingSave', false)
          resolve(res)
        }).catch(err => {
          commit('setMessageLoadingSave', false)
          reject(err)
        })
      })
    },
    getById ({ state, commit }, id) {
      return new Promise((resolve, reject) => {
        getById(id).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/message-manage.js